import { createContext, useContext } from 'react';

const ACProjectContext = createContext({
  moduleStudy: {},
  definitionList: [],
  activeAccountId: '',
  uid: '',
  definitionTarget: [],
  defDataPoints: [],
});

export const useACProjectContext = () => useContext(ACProjectContext);

export default ACProjectContext;
